import axios from 'axios';

const settings = window.APP_SETTINGS;

export const getStates = () => {
	return axios.get(`${settings.EXPERT_API_BASE_URL}/states`);
};
